import React from "react";

const DashboardFooter = ()=>{
    return(
        <footer className="footer">
            <div className="container-fluid">
                {/* <div className="row">
                    <div className="col-sm-6">
                    &copy; {new Date().getFullYear()} Realesy
                    </div>
                    <div className="col-sm-6">
                        <div className="text-sm-end d-none d-sm-block">
                            Design & Developed by <a href="https://sellklever.com/" target="_blank">Sellklever</a>
                        </div>
                    </div>
                </div> */}
            </div>
        </footer>
    );
}

export default DashboardFooter;